export function priceToEarningsCalc(lastEps, price) {

    return (price/lastEps).toFixed(2)
}